
import { 
  defineComponent, 
  computed, 
  watch, 
  inject,
  ref,
  onBeforeUnmount 
} from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import type { VueFinalModalProperty } from 'vue-final-modal'

import { ACTIONS_KEYS } from '@/store/actions'

import VideoPlayer from '@/components/VideoPlayer.vue'
import VideoFavorite from '@/components/VideoFavorite.vue'

// TODO: 強化 REGEX_HASHTAG 細節
const REGEX_HASHTAG = /(?<!\S)#(\w|[\u3400-\uFFFD])+/g
const REGEX_LINK = /(http|https):\/\/([\w.]+\/?)\S*/g

function pipe<T> (...fns: ((val: T) => T)[]) {
  return (value: T) => fns.reduce((val, fn) => fn(val), value)
}

/**
 * 解析超連結
 * @param {String} value 待解析字串
 * @returns {String} 解析完畢字串
 */
function parserLink (value: string) {
  const linkCass = 'text-green-600 hover:underline'
  const linkAttrs = 'target="_blank" rel="noopener"'
  return value.replace(REGEX_LINK, str =>
    `<a ${linkAttrs} class="${linkCass}" href="${str}">${str}</a>`
  )
}

/**
 * 解析 hashtag
 * @param {String} value 待解析字串
 * @returns {String} 解析完畢字串
 */
function parserHashtag (value: string) {
  const hashtagClass =
    'inline-block ' +
    'text-green-600 hover:underline ' +
    'mr-1 ' +
    'select-none '
  return value.replace(REGEX_HASHTAG, str => {
    str = str.trim()
    const linkBase = 'https://www.youtube.com/results'
    // encodeURIComponent('#') => '%23'
    const linkHref = `${linkBase}?search_query=${str.replace('#', '%23')}`
    const linkAttrs = 'target="_blank" rel="noopener"'
    return `<a ${linkAttrs} class="${hashtagClass}" href="${linkHref}">${str}</a>`
  })
}

export default defineComponent({
  components: {
    VideoPlayer,
    VideoFavorite
  },
  setup () {
    const store = useStore()
    const route = useRoute()

    const $vfm = inject<VueFinalModalProperty>('$vfm')

    /**
     * Youtube 廣告區塊是否開啟
     */
    const isAdShow = ref(false)

    const id = computed(() => route.params.id)
    const video = computed(() => store.state.currentVideo)

    const description = computed(() => {
      if(!video.value) { return '' }
      return pipe<string>(
        parserLink,
        parserHashtag
      )(video.value.description)
    })

    const unwatch = watch(id, id => {
      if (!id) { return }
      if (Array.isArray(id)) {
        id = id[0]
      }
      store.dispatch(ACTIONS_KEYS.GET_VIDEO_BY_ID, id)
    }, {
      immediate: true
    })

    let timeout: number | undefined
    const onPaused = () => {
      if(!$vfm) { return }
      timeout = setTimeout(()=> isAdShow.value = true, 1000)
    }

    const onPlaying = () => {
      if(!$vfm) { return }
      if(typeof timeout === 'number') {
        clearTimeout(timeout)
      }
    }
    
    onBeforeUnmount(() => { unwatch() })

    return {
      id,
      video,
      description,
      onPaused,
      onPlaying,
      isAdShow
    }
  }
})
